/**
 * Последний живой кадр ленты: F5 не ждёт сокет, чтобы показать строки.
 *
 * Без этого обновление вкладки всегда рисует «собираем вилки», хотя те же
 * вилки только что были на экране. Держим полторы минуты: короткий клин
 * такта 8–15 с иначе убивает кэш раньше, чем человек успевает нажать F5.
 */

import { feedKey } from '../lib/feedContext';
import type { Fork } from '../lib/protocol';

/** Переживает обычный F5 и короткий клин такта (8–15 с), не вчерашнюю цену. */
export const LAST_FRAME_TTL_MS = 90_000;
const KEY = (): string => feedKey('forq.feed.last');
const MAX_ROWS = 80;

export interface LastFrame {
  forks: Fork[];
  proto: number;
  at: number;
}

function slot(): Storage | null {
  try {
    return sessionStorage;
  } catch {
    return null;
  }
}

export function saveLastFrame(forks: Iterable<Fork>, proto: number, at = Date.now()): void {
  const store = slot();
  if (store === null) return;
  const rows = [...forks].slice(0, MAX_ROWS);
  if (rows.length === 0) return;
  try {
    store.setItem(KEY(), JSON.stringify({ at, proto, forks: rows }));
  } catch {
    // Приватный режим / квота — не повод ронять ленту.
  }
}

export function readLastFrame(now = Date.now()): LastFrame | null {
  const store = slot();
  if (store === null) return null;
  try {
    const raw = store.getItem(KEY());
    if (raw === null || raw === '') return null;
    const data = JSON.parse(raw) as Partial<LastFrame>;
    if (typeof data.at !== 'number' || now - data.at > LAST_FRAME_TTL_MS) return null;
    if (!Array.isArray(data.forks) || data.forks.length === 0) return null;
    const proto = typeof data.proto === 'number' && Number.isFinite(data.proto) ? data.proto : 0;
    return { at: data.at, proto, forks: data.forks as Fork[] };
  } catch {
    return null;
  }
}
